export default function truncateTitle(title: string, maxLength: number): string {
    if (!title) {
        return '';
    }

    if (title.length < maxLength) {
        return title;
    }

    let newTitle = title.substr(0, maxLength).trim();
    return newTitle + '...';
}
